import React, { Component } from 'react';

class ErrorPopup extends Component {
  constructor(props) {
    super(props);
    this.state = { isErrorVisible: true };
  }

 

  render() {
    return (
      <div>
        {this.state.isErrorVisible && <div className="error-popup" onClick={this.props.onClick}>{this.props.errorText}</div>}
      </div>
    );
  }
}

export default ErrorPopup;
